// extracted by mini-css-extract-plugin
module.exports = {"top":"top_top__2M5va","icon":"top_icon__3dTYc"};